import { omit } from 'lodash';
import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import {
  createTemplate,
  deleteTemplate,
  selectTemplate,
  updateTemplate,
} from '../../../../modules/templates.js';
import FormModal from '../../../FormModal.jsx';
import TemplateForm from './TemplateModal.jsx';

const mapStateToProps = (state, ownProps) => ({
  template: omit(selectTemplate(state, ownProps), ['id']),
});

const mapDispatchToProps = {
  createTemplate,
  deleteTemplate,
  updateTemplate,
};

TemplateFormModal.propTypes = {
  templateId: PropTypes.number,
  onHide: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
};

function TemplateFormModal({
  template,
  templateId,
  createTemplate,
  deleteTemplate,
  onHide,
  show,
  updateTemplate,
}) {
  const deleteResource = useCallback(
    () => deleteTemplate(templateId),
    [deleteTemplate, templateId]
  );

  const updateResource = useCallback(
    (values) => updateTemplate(templateId, values),
    [templateId, updateTemplate]
  );

  const validate = useCallback((values) => {
    const errors = {};
    if (!values.name) {
      errors.name = 'Title is required';
    }
    if (!values.url) {
      errors.url = 'URL is required';
    }
    return errors;
  }, []);

  return (
    <FormModal
      createResource={createTemplate}
      deleteResource={deleteResource}
      onHide={onHide}
      resource={template}
      resourceName="template"
      show={show}
      updateResource={updateResource}
      validate={validate}
    >
      <TemplateForm />
    </FormModal>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TemplateFormModal);
